import type { SxProps, Theme } from '@mui/material';

import { varAlpha } from 'src/theme/styles';

export const stepHeaderPillSx = (selected = false): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
  height: 40,
  minWidth: 40,
  px: 1,
  borderRadius: 999,
  border: '1px solid',
  borderColor: selected ? 'text.primary' : (theme) => varAlpha(theme.vars.palette.grey['500Channel'], 0.32),
  borderWidth: selected ? '1.5px' : '1px',
  bgcolor: 'background.paper',
  flexShrink: 0,
});

export const stepHeaderPillLabelSx: SxProps<Theme> = {
  fontSize: 13,
  fontWeight: 700,
  lineHeight: '22px',
  color: 'text.primary',
  whiteSpace: 'nowrap',
};

export const stepHeaderPillBadgeSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  px: 0.75,
  borderRadius: 999,
  bgcolor: (theme) => varAlpha(theme.vars.palette.grey['500Channel'], 0.24),
  fontSize: 12,
  fontWeight: 700,
  lineHeight: '20px',
  color: 'text.primary',
  textAlign: 'center',
};

export const stepHeaderMenuItemSx: SxProps<Theme> = {
  mx: 1,
  my: 0.5,
  borderRadius: 1,
  fontSize: 13,
  fontWeight: 600,
  transition: 'none !important',
  '&:hover': { bgcolor: 'action.hover' },
  '&:active': { bgcolor: 'transparent' },
  '&:focus-visible': { bgcolor: 'transparent' },
};
